//#region Imports
/**
To use React related functionality
*/
import React from 'react';
/**
To use exchange icon
*/
import {IconExchange} from '../Icons';
//#endregion


/**
* Used in Planner>>Index
*/
const ExchangeButton = ({handleClick, showSummary}) => {
    //if showSummary is true then return blank.
    if (showSummary) return '';
    return(
        <button
            type="button"
            onClick={ () => handleClick() }
            className="otp-swap-btn">
            <IconExchange />
        </button>
    );
};

export default ExchangeButton;